import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { NeedOfDisabilityService } from '@ascschool/services/category/need-of-disability.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { TypeOfEducationInvolveService } from '@ascschool/services/category/type-of-education-involve.service';
import { TypeofEducationService } from '@ascschool/services/category/typeofeducation.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { Observable,Subject} from 'rxjs';
import { map,takeUntil } from 'rxjs/operators';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { EnsureConditionService } from '@ascschool/services/category/ensure-condition.service';
@Component({
  selector: 'app-bc-cs-giao-duc',
  templateUrl: './bc-cs-giao-duc.component.html',
  styleUrls: ['./bc-cs-giao-duc.component.scss']
})
export class BcCsGiaoDucComponent implements OnInit,OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef, public _authService: AuthService, public sizePageService: SizePageService,
    private authQuery: AuthQuery, public utilService: UtilsService, private service: BaocaoService,
    private typeofEducationService: TypeofEducationService, private disSchoolLevelsService: SchoolLevelService,
    private caDisTypeOfEducationInvolvesService: TypeOfEducationInvolveService,
    private caDisNeedOfDisabilitysService: NeedOfDisabilityService, private disProvincesService: ProvinceService,
    private districtService: DistrictService, private wardService: WardService,
    private disTypeOfSchoolsService: TypeOfSchoolService, private ensureConditionService: EnsureConditionService,
  ) { }
  get breadcrumbs(): string[] {
    return ['Báo cáo tổng hợp'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  $unSubscribe= new Subject();
  year = '';
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  thongtinCSGDList: any;
  ListCapHoc: any[] = [];
  ListLoaiHinh: any[] = [];
  ListDieuKien: any[] = [];
  firstRowOnPage: any;
  dataList: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('Table', { static: false }) tableElement: NzTableComponent;
  show = false; maxHeight: number; height: number; heightPopup: number; heightPagnagation: number = 50; isCollapse = true;
  getProvinceACFn: (value: any) => Observable<any>; ProvinceSubscription: any; ProvinceControl = new FormControl();
  getTypeofEducationACFn: (value: any) => Observable<any>; TypeofEducationSubscription: any; TypeofEducationControl = new FormControl();
  getDisSchoolLevelsACFn: (value: any) => Observable<any>; DisSchoolLevelsSubscription: any; DisSchoolLevelsControl = new FormControl();
  getCaDisTypeOfEducationInvolvesACFn: (value: any) => Observable<any>; caDisTypeOfEducationInvolvesSubscription: any; caDisTypeOfEducationInvolvesControl = new FormControl();
  getCaDisNeedOfDisabilitysACFn: (value: any) => Observable<any>; caDisNeedOfDisabilitysSubscription: any; caDisNeedOfDisabilitysControl = new FormControl();
  getDisProvincesACFn: (value: any) => Observable<any>; DisProvincesSubscription: any; DisProvincesControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>; DistrictSubscription: any; DistrictControl = new FormControl();
  getDisWardACFn: (value: any) => Observable<any>; DisWardSubscription: any; DisWardControl = new FormControl();
  getDisTypeOfSchoolsACFn: (value: any) => Observable<any>; disTypeOfSchoolsSubscription: any; disTypeOfSchoolsControl = new FormControl();
  getLivingConditionsACFn: (value: any) => Observable<any>; LivingConditionSubscription: any; LivingConditionControl = new FormControl();
  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.loadTypeofEducation();
    this.loadDisSchoolLevels();
    this.loadDisProvinces();
    this.loadDisTypeOfSchools();
    this.loadLivingCondition();
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe(() => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
  }
  changeYear() {
    this.commonFilter.year = this.year;
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.thongtinCSGDList = [];
    this.changeYear();
    this.service.GetReportCsgdInfo(this.commonFilter)
    .pipe(takeUntil(this.$unSubscribe)).subscribe(
      (response: any) => {
        if (response.data) {
          const total = response.pivotCh.chOrder;
          const list = response.data ? response.data : [];
          this.Total = (response && response.rowCount) ? response.rowCount : 0;
          this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
          _this.thongtinCSGDList = (list) ? list : [];
        }
        if (response) {
          this.ListCapHoc = response.pivotCh;
          this.ListLoaiHinh = response.pivotLh;
          this.ListDieuKien = response.pivotDk;
        } else {
          this.ListCapHoc = [];
        }
        _this.loading = false;
      }, (err: any) => {
        _this.thongtinCSGDList = [];
        _this.loading = false;
      }
    );
  }
  exportExcel() {
    // document.getElementById('btnvF').click();
    this.commonFilter.year = this.year;
    let filter: any = this.commonFilter;
    delete filter.PageSize;
    delete filter.PageIndex;
    this.service.exportExcelCsgdInfo(filter).subscribe((data) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'THTTVCCSGD.xlsx';
      link.click();
    });
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    // this.width = window.innerWidth;
    this.checkCaculateHeight(this.isCollapse);
    this.width = this.widthfnc();
    setTimeout(() => {
      this.reload();
      this.tableElement.scrollX = 1500 + 'px';
    }, 100);

    // keyboard
    this.shortcuts.push({
      key: ['alt + n'], label: 'Help', description: 'Cmd + b', command: (e) => console.log('alt + n'), preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm(): void { }
  loadTypeofEducation() {
    // tslint:disable-next-line: max-line-length
    this.getTypeofEducationACFn = (value: any) => this.typeofEducationService.getTypeofEducationSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfEducationName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.TypeofEducationSubscription) {
      this.TypeofEducationSubscription = this.TypeofEducationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'typeOfEducationId', this.TypeofEducationControl.value);
      });
    }
  }
  changeEducationACFn(control: FormControl) {
    this.TypeofEducationControl = control;
  }
  loadDisSchoolLevels() {
    // tslint:disable-next-line: max-line-length
    this.getDisSchoolLevelsACFn = (value: any) => this.disSchoolLevelsService.getSchoolLevelsSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.schoolLevelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.DisSchoolLevelsSubscription) {
      this.DisSchoolLevelsSubscription = this.DisSchoolLevelsControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolLevelId', this.DisSchoolLevelsControl.value);
      });
    }
  }
  changeDisSchoolLevels(control: FormControl) {
    this.DisSchoolLevelsControl = control;
  }
  loadCaDisTypeOfEducationInvolves() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisTypeOfEducationInvolvesACFn = (value: any) => this.caDisTypeOfEducationInvolvesService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.caDisTypeOfEducationInvolvesSubscription) {
      this.caDisTypeOfEducationInvolvesSubscription = this.caDisTypeOfEducationInvolvesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolLevelId', this.caDisTypeOfEducationInvolvesControl.value);
      });
    }
  }
  changeCaDisTypeOfEducationInvolves(control: FormControl) {
    this.caDisTypeOfEducationInvolvesControl = control;
  }

  loadCaDisNeedOfDisabilitys() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisNeedOfDisabilitysACFn = (value: any) => this.caDisNeedOfDisabilitysService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.caDisNeedOfDisabilitysSubscription) {
      this.caDisNeedOfDisabilitysSubscription = this.caDisNeedOfDisabilitysControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'modesOfEducationId', this.caDisNeedOfDisabilitysControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeCaDisNeedOfDisabilitys(control: FormControl) {
    this.caDisNeedOfDisabilitysControl = control;
  }
  loadDisProvinces() {
    // tslint:disable-next-line: max-line-length
    this.getDisProvincesACFn = (value: any) => this.disProvincesService.getProvinceSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.DisProvincesSubscription) {
      this.DisProvincesSubscription = this.DisProvincesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.DisProvincesControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisProvincesACFn(control: FormControl) {
    this.DisProvincesControl = control;
    if (this.DisProvincesControl) {
      this.loadDistrict();
      this.DistrictControl.setValue(null);
    }
  }
  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({ searchTerm: value, ProvinceId: this.valueIfHas(this.DisProvincesControl), PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDistrictACFn(control: FormControl) {
    this.DistrictControl = control;
    if (this.DistrictControl) {
      this.loadDisWard();
      this.DisWardControl.setValue(null);
    }
  }
  loadDisWard() {
    // tslint:disable-next-line: max-line-length
    this.getDisWardACFn = (value: any) => this.wardService.getWardSelectPaging({ searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.DisWardSubscription) {
      this.DisWardSubscription = this.DisWardControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'WardId', this.DisWardControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisWardACFn(control: FormControl) {
    this.DisWardControl = control;
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') { return control.value.id; }
    return '';
  }
  loadDisTypeOfSchools() {
    // tslint:disable-next-line: max-line-length
    this.getDisTypeOfSchoolsACFn = (value: any) => this.disTypeOfSchoolsService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfSchoolName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.disTypeOfSchoolsSubscription) {
      this.disTypeOfSchoolsSubscription = this.disTypeOfSchoolsControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfSchoolId', this.disTypeOfSchoolsControl.value);
      });
    }
  }
  changeDisTypeOfSchools(control: FormControl) {
    this.disTypeOfSchoolsControl = control;
  }

  loadLivingCondition() {
    // tslint:disable-next-line: max-line-length
    this.getLivingConditionsACFn = (value: any) => this.ensureConditionService.getEnsureConditionSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.LivingConditionSubscription) {
      this.LivingConditionSubscription = this.LivingConditionControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'EnsureConditionId', this.LivingConditionControl.value);
      });
    }
  }
  changeLivingCondition(control: FormControl) {
    this.LivingConditionControl = control;
  }
  clear() {
    this.year = '';
    this.TypeofEducationControl.setValue(null);
    this.DisSchoolLevelsControl.setValue(null);
    this.DisProvincesControl.setValue(null);
    this.DistrictControl.setValue(null);
    this.DisWardControl.setValue(null);
    this.disTypeOfSchoolsControl.setValue(null);
    this.LivingConditionControl.setValue(null);
    this.reload();
  }
  ngOnDestroy(): void {
    this.$unSubscribe.next();
    this.$unSubscribe.complete();
}
}
